/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://wc4xktuob5e2dfpjpbxrzkfscy.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:12c2f9e6-168d-4f31-ad18-4a7934db4595",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_sphyUyGg7",
    "aws_user_pools_web_client_id": "db5i7oq1mlis3hm07qjp0vu8a",
    "oauth": {
        "domain": "eat2gether-staging.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/,https://admin.2gether-staging.rocks/,https://poker.2gether-staging.rocks/,https://retro.2gether-staging.rocks/,https://sit.2gether-staging.rocks/,https://www.sit2gether.materna.de/",
        "redirectSignOut": "http://localhost:3000/,https://2gether-staging.rocks/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME",
        "FAMILY_NAME",
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SeatUsage-opentext",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "sit2getherroomplanstorage131828-opentext",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
